<template>
	<div>
		<div>{{ titulo }}</div>
		<div class="mb-2">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DetalheComponent2',
	props: {
		titulo: {
			type: String,
			default: ''
		}
	}
}
</script>
